import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import he from './locales/he.json';
import en from './locales/en.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      he: { translation: he },
      en: { translation: en },
    },
    lng: 'en',
    fallbackLng: 'he',
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false,
    },
  });

// Sync document dir/lang with detected language on init and on every change
const syncDir = (lng: string) => {
  const dir = lng === 'he' ? 'rtl' : 'ltr';
  document.documentElement.dir = dir;
  document.documentElement.lang = lng;
};
syncDir(i18n.language || 'en');
i18n.on('languageChanged', syncDir);

export default i18n;
